// Test IDs for the auth feature (login, password reset, logout).
// Phase A · Iter 24: Register/2FA removed — REGISTER left empty so any leftover
// imports surface as JSX undefined instead of pointing at a dead page.

export const LOGIN = {
	emailInput: 'login-email-input',
	passwordInput: 'login-password-input',
	submitButton: 'login-submit-button',
	forgotPasswordLink: 'login-forgot-password-link',
};

export const REGISTER = {};

export const LOGOUT = {
	button: 'logout-button',
};
